export default "__VITE_PUBLIC_ASSET__629a3489__"